import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';

export interface IConfirmModalProps {
    title:string;
    text: string;
    open: boolean;
    handleConfirm: () => any,
    onClose: () => any
}


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export default function ConfirmModal({ title, text, handleConfirm, onClose, open }:IConfirmModalProps) {
    
    const handleClose = () => {
        onClose()
    };

    const confirmHandler = () => {
        handleConfirm()
        onClose()
    }

    return (
        <React.Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                style={{ borderRadius: '10px' }}
                PaperProps={{style:{padding:'15px', minWidth:'300px'}}}
            >
                <DialogTitle style={{
                    font: '30px',
                    fontWeight: 400,
                    lineHeight: "36px",
                    letterSpacing: "0.004em",
                    padding:0
                }}>{title}</DialogTitle>
                <DialogContent style={{padding:'20px 0'}}>
                    <DialogContentText id="alert-dialog-slide-description"
                        style={{
                            fontSize: "20px",
                            fontWeight: 400,
                            lineHeight: "29px",
                            letterSpacing: "0.004em",
                        }}>
                        {text}
                    </DialogContentText>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogContent>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <Button variant='outlined' color='secondary' onClick={handleClose}>No</Button>
                    <Button variant='contained' color='primary' onClick={confirmHandler}>Yes</Button>
                </div>
            </Dialog>
        </React.Fragment >
    );
}